//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCalendar } from "@/api/management/showcase";
export default {
  name: "SchoolDate",
  props: ["itemData", "type"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      value: "",
      addDateShow: false,
      form: {
        name: "",
        region: "",
        times: ""
      },
      formLabelWidth: "120px",
      calData: {},
      weekList: [],
      calendarData: [],
      parmMon: ""
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.getCalendarList();
    this.$nextTick(function () {
      // 点击前一个月
      var prevBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(1)");
      prevBtn.addEventListener("click", function () {
        var date = new Date(_this.value);
        var monDate = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        _this.parmMon = date.getFullYear() + "-" + monDate;

        _this.getCalendarList();
      });
    }), this.$nextTick(function () {
      // 点击后一个月
      var prevBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:last-child");
      prevBtn.addEventListener("click", function () {
        var date = new Date(_this.value);
        var monDate = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        _this.parmMon = date.getFullYear() + "-" + monDate;

        _this.getCalendarList();
      });
    });
  },
  methods: {
    //获取校历周
    getCalendarList: function getCalendarList() {
      var _this2 = this;

      var params = {
        dateStr: this.parmMon || ""
      };
      getCalendar(params).then(function (_ref) {
        var data = _ref.data;
        _this2.calData = data.data;
        _this2.weekList = (data.data || {}).weekArr || [];
        _this2.calendarData = (data.data || {}).thingArr || [];
      });
    },
    // 添加事件
    addSc: function addSc() {
      this.addDateShow = true;
    },
    handleClose: function handleClose(done) {
      this.$confirm("确认关闭？").then(function (_) {
        done();
      }).catch(function (_) {});
    }
  },
  filters: {
    ellipsis: function ellipsis(value) {
      if (!value) return "";

      if (value.length > 2) {
        return value.slice(0, 2) + "...";
      }

      return value;
    }
  }
};